import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

const styles = {
  formBody: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    margin: { bottom: '6.4rem', left: 'auto', right: 'auto' },
    padding: {
      top: '3.2rem',
      bottom: '3.6rem',
    },
    display: 'flex',
    justifyContent: 'center',
    minHeight: '20rem',
    position: 'relative',
  },
  disableFormBody: {
    cursor: 'not-allowed',
    '&::after': {
      position: 'absolute',
      content: "''",
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      zIndex: 10,
    },
  },
  innerWrapper: {
    flex: '0 100 80%',
    '@media(max-width: 1124px)': {
      flexBasis: '90%',
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem',
    marginBottom: '9.6rem',
  },
  button: {
    [breakpoints.sm.down]: {
      width: '100%',
      minWidth: 'unset',
    },
  },
  spinnerBg: { borderRadius: '0.6rem' },
};

const createStyles = createUseStyles(styles);

export { createStyles };
